export default {
  exportUserLogin(st) {
    return st.userLogin;
  },
  exportTopBarSearchBarMobileActive(st) {
    return st.topBarStatus.isSearchBarMobileActive;
  },
  exportTopBarNotifyActive(st) {
    return st.topBarStatus.isNotifyFocus;
  },
  exportTopBarFeatureActive(st) {
    return st.topBarStatus.isUserFeatureFocus;
  },
  exportTopBarPanelActive(st) {
    return st.topBarStatus.isUserPanelFocus;
  },
  exportHamburgerActive(st) {
    return st.topBarStatus.isHamburgerFocus;
  },
  exportTopBarStatus(st) {
    return st.topBarStatus;
  },
  exportLoginStatus(st) {
    return st.userLogin.isLogin;
  },
  exportUserHashCode(st) {
    return st.userLogin.hashCode;
  },
  exportUserDjangoId(st) {
    return st.userLogin.djangoId;
  },
  exportUserProfile(st) {
    return st.userLogin.profile;
  },
  exportUserJwtToken(st) {
    return st.jwtToken;
  },
  exportUserScoreTicker(st) {
    return st.scoreTicker;
  },
  exportUserScoreStatus(st) {
    return st.scoreStatus;
  },
  exportUserShopCart(st) {
    return st.shopCart;
  },
  exportUserSubscribeBindVendor(st) {
    return st.subscribe.bindVendor;
  },
  exportUserSubscribeVip(st) {
    return st.subscribe.viper;
  },
  exportUserSubscribeValid(st) {
    return st.subscribe.valid;
  },
  exportUserSubscribeExpire(st) {
    return st.subscribe.expire;
  },
  exportConsultWebSocket(st) {
    return st.consultWebSocket;
  },
  exportExclusiveWebSocket(st) {
    return st.exclusiveWebSocket;
  },
  exportUserShopCartFlow(st) {
    return st.shopCartFlow;
  },
  exportUserShopPurchaseType(st) {
    return st.shopPurchaseType;
  },
  exportEproSetupActive(st) {
    return st.userLogin.profile.personal_id ? true : false;
  },
  exportLiffVendorHash(st) {
    return st.liffVendor;
  },
};
